var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLink = function SvgLink(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.464 4.937l.598.598h-.003a3.21 3.21 0 0 1 0 4.542l-3.891 3.891a3.188 3.188 0 0 1-2.271.94 3.186 3.186 0 0 1-2.27-.94.668.668 0 0 1-.014-.963.67.67 0 0 1 .963.016 1.856 1.856 0 0 0 1.32.547 1.858 1.858 0 0 0 1.323-.548l3.891-3.89a1.867 1.867 0 0 0 0-2.645l-.599-.6a1.871 1.871 0 0 0-2.644 0l-1.945 1.946a.67.67 0 0 1-.949-.948l1.949-1.946a3.22 3.22 0 0 1 4.542 0zM9.13 18.112l1.836-1.836.002-.002a.672.672 0 0 1 .949.95l-1.836 1.834a3.212 3.212 0 0 1-4.542 0l-.598-.597a3.211 3.211 0 0 1 0-4.542l3.89-3.89a3.214 3.214 0 0 1 4.543 0l.599.598a.673.673 0 0 1-.951.95l-.6-.598a1.87 1.87 0 0 0-2.644 0l-3.89 3.891a1.87 1.87 0 0 0 0 2.644l.598.598a1.914 1.914 0 0 0 2.644 0z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "link.60289724076b22c15041b0f939206a23.svg";